export const readPostTypeBoolean = (
  record: unknown,
  keys: string[],
  fallback = false,
): boolean => {
  if (!record || typeof record !== "object") return fallback;
  const o = record as Record<string, unknown>;
  for (const key of keys) {
    const value = o[key];
    if (value === true || value === false) return value;
    if (value === "true") return true;
    if (value === "false") return false;
  }
  return fallback;
};

export const normalizePostTypeTaxes = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value.map((v) => String(v).trim()).filter(Boolean);
  }
  if (value == null || value === "") return [];
  return [String(value).trim()].filter(Boolean);
};

export const postTypeTaxDetailPayload = (state: {
  giftCardFunctionality: boolean;
  giftCard: boolean;
  selectedTax: string[];
  roomRevenue: boolean;
  resource: boolean;
  roomRental: boolean;
  food: boolean;
  beverage: boolean;
  other: boolean;
}) => ({
  isGiftCard: state.giftCardFunctionality,
  giftCardType: state.giftCard ?? false,
  taxes: state.selectedTax ?? [],
  isRoomRevenue: state.roomRevenue,
  isResource: state.resource,
  isRoomRental: state.roomRental,
  isFood: state.food,
  isBeverage: state.beverage,
  isOther: state.other,
  isFoodAndBevClassifier: state.food || state.beverage,
});

export const readPostTypeTaxDetailsFromRecord = (list: unknown) => {
  const food =
    readPostTypeBoolean(list, ["isFood", "food"]) ||
    readPostTypeBoolean(list, ["isFoodAndBevClassifier"]);
  const beverage =
    readPostTypeBoolean(list, ["isBeverage", "beverage"]) ||
    readPostTypeBoolean(list, ["isFoodAndBevClassifier"]);

  return {
    giftCardFunctionality: readPostTypeBoolean(list, ["isGiftCard"]),
    giftCard: readPostTypeBoolean(list, ["giftCardType"]),
    selectedTax: normalizePostTypeTaxes(
      list && typeof list === "object"
        ? (list as Record<string, unknown>).taxes
        : undefined,
    ),
    roomRevenue: readPostTypeBoolean(list, ["isRoomRevenue", "roomRevenue"]),
    resource: readPostTypeBoolean(list, ["isResource", "resource"]),
    roomRental: readPostTypeBoolean(list, ["isRoomRental", "roomRental"]),
    food,
    beverage,
    other: readPostTypeBoolean(list, ["isOther", "other"]),
  };
};
